let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("av1tZ")).then(() => parcelRequire('fXmRq'));